import { render, staticRenderFns } from "./RziDocumentationSettings.vue?vue&type=template&id=7dc5afae&"
import script from "./RziDocumentationSettings.vue?vue&type=script&lang=js&"
export * from "./RziDocumentationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports